export default __webpack_public_path__ + "static/media/Entertainment-hover.c101b0b2.svg";